// Central content + asset data for the INN'SPECTIVE landing page (German)

export const LOGO_URL =
  "https://customer-assets-gfyr7b9c.emergentagent.net/job_secure-it-solutions-3/artifacts/gr5u8p7x_LogoFinal1280x666.png";

export const CONTACT = {
  email: "office@innspective.at",
  phone: "+43 664 99513107",
  phoneHref: "tel:+4366499513107",
  address: "Bachgasse 2c, 6065 Thaur",
  founder: "Benjamin Hofmann",
  role: "IT Technical Consultant & Gründer",
};

export const SERVICES = [
  {
    id: "on-premises",
    number: "01",
    label: "Infrastruktur & Betrieb",
    title: "On-Premises IT",
    description:
      "Ihre Server, Ihr Netzwerk, Ihre Daten – im eigenen Haus. Ich plane, richte ein und betreue leistungsfähige lokale Infrastruktur, die zuverlässig läuft und Ihnen die volle Kontrolle über Ihre Daten lässt. Klar strukturiert, sauber dokumentiert.",
    points: [
      "Server- & Netzwerkinfrastruktur",
      "Virtualisierung & Backup-Konzepte",
      "Wartung, Monitoring & Support",
    ],
    image:
      "https://images.unsplash.com/photo-1680992046626-418f7e910589?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    id: "cloud",
    number: "02",
    label: "Identity & Endpoint",
    title: "Microsoft 365",
    description:
      "Microsoft 365 bildet die Grundlage für modernes, sicheres Arbeiten. Ich unterstütze Unternehmen bei der Einführung, Migration und laufenden Betreuung ihrer Microsoft-365-Umgebung – inklusive Identity & Access Management sowie zentralem Gerätemanagement mit Microsoft Intune.",
    points: [
      "Microsoft 365 (SaaS) – Einrichtung, Migration & Verwaltung",
      "Microsoft Entra ID & Identity Management",
      "Conditional Access & Multi-Faktor-Authentifizierung (MFA)",
      "Microsoft Intune – Geräteverwaltung & Endpoint Security",
    ],
    image:
      "https://images.unsplash.com/photo-1561233835-f937539b95b9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    id: "security",
    number: "03",
    label: "Sicherheit",
    title: "IT-Security",
    description:
      "IT-Sicherheit ist kein einmaliges Projekt, sondern ein kontinuierlicher Prozess. Ich reduziere Angriffsflächen durch die konsequente Härtung lokaler und cloudbasierter Systeme, strukturiertes Schwachstellenmanagement und moderne Schutzmaßnahmen für Identitäten und Endgeräte.",
    points: [
      "Härtung lokaler und cloudbasierter IT-Infrastrukturen",
      "Schwachstellenmanagement und Sicherheitsbewertungen",
      "Identitäts- und Endgeräteschutz mit Microsoft Security",
    ],
    image:
      "https://images.pexels.com/photos/38482455/pexels-photo-38482455.jpeg?auto=compress&cs=tinysrgb&w=1200",
  },
];

export const FOUNDER_IMAGE =
  "https://customer-assets-gfyr7b9c.emergentagent.net/job_secure-it-solutions-3/artifacts/i74xn7l4_BusinessPortrait.jpg";
